import React from 'react';
import {
  CircularProgress as MUICircularProgress,
  CircularProgressProps as MUICircularProgressProps,
} from '@mui/material';

import colors from '@atom/styles/colors';

type CustomProps = {
  style?: React.CSSProperties;
  progressColor?: string;
};

type AtomMUIProps = {
  size?: number;
  thickness?: number;
};

export type ProgressProps = CustomProps & AtomMUIProps;

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
  },
};

export const Progress = (props: ProgressProps) => {
  const {
    size = 50,
    thickness = 3,
    progressColor = colors.brand.blue,
    style = {},
    ...data
  } = props;

  const MUIProps: MUICircularProgressProps = data;

  return (
    <div style={{ ...styles.container, ...style }}>
      <MUICircularProgress
        size={size}
        thickness={thickness}
        style={{ color: progressColor }}
        {...MUIProps}
      />
    </div>
  );
};

export default Progress;
